module.exports = __webpack_public_path__ + "static/media/Admin_Selected.2cdb9e85.svg";